const preferencesConfigAction = (preferencesConfig) => ({
  type: 'SET_PREFERENCES',
  preferencesConfig,
});

export default preferencesConfigAction;
